import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  Td
} from '@chakra-ui/react';
import { api } from '../../../services/api';
import { useQuery } from 'react-query';


async function getInfoCustomer(codVendedor) {
  const response = await api.get(`/site/v2/crm-controle/chamados-vendedor/${codVendedor}`)

  return response.data
}

export function InfoVendedor({ codVendedor, nomeVendedor }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data, isLoading } = useQuery({
    queryKey: ['info-customer', codVendedor],
    queryFn: () => getInfoCustomer(codVendedor),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10
  })

  console.log(data)

  return (
    <>
      <Button onClick={onOpen}>{nomeVendedor}</Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Vendedor - {nomeVendedor}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table>
              <Thead>
                <Th>Nome</Th>
                <Th>Chamados no dia</Th>
                <Th>Chamados na semana</Th>
                <Th>Chamados no mês</Th>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>{nomeVendedor}</Td>
                  <Td>{data?.chamados_dia}</Td>
                  <Td>{data?.chamados_semanal}</Td>
                  <Td>{data?.chamados_mes}</Td>
                </Tr>
              </Tbody>
            </Table>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
